const PLANT_API_BASE_URL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_URL_PREFIX}/plantapi/V1`;

const radioOptionsYesNo = [
  {
    value: 'yes',
    label: 'Yes',
  },
  {
    value: 'no',
    label: 'No',
  },
];

const selectAustraliaStateOptions = [
  { text: 'ACT', value: 'ACT' },
  { text: 'NSW', value: 'NSW' },
  { text: 'NT', value: 'NT' },
  { text: 'QLD', value: 'QLD' },
  { text: 'SA', value: 'SA' },
  { text: 'TAS', value: 'TAS' },
  { text: 'VIC', value: 'VIC' },
  { text: 'WA', value: 'WA' },
];

const stepperStatus = {
  completed: 'completed',
  current: 'current',
  todo: 'todo',
};

const SAFEWORK_PRIVACY_STATEMENT_URL =
  'https://www.safework.nsw.gov.au/about-us/privacy/safework-nsw-privacy-statement';
const SNSW_PRIVACY_STATEMENT_URL = 'https://www.service.nsw.gov.au/privacy-statement';
const PRIVACY_COLLECTION_NOTICE_URL =
  'https://www.safework.nsw.gov.au/about-us/privacy/collection-notices/plant-registration';
const PRIVACY_MANAGEMENT_PLAN_URL = 'https://www.safework.nsw.gov.au/about-us/privacy/safework-privacy-management-plan';

export {
  PLANT_API_BASE_URL,
  radioOptionsYesNo,
  selectAustraliaStateOptions,
  stepperStatus,
  SAFEWORK_PRIVACY_STATEMENT_URL,
  SNSW_PRIVACY_STATEMENT_URL,
  PRIVACY_COLLECTION_NOTICE_URL,
  PRIVACY_MANAGEMENT_PLAN_URL,
};
